import InformeGastos from "./InformeGastos";
export default InformeGastos;